import { render, staticRenderFns } from "./Contabili.vue?vue&type=template&id=20379d88&"
import script from "./Contabili.vue?vue&type=script&lang=js&"
export * from "./Contabili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports